/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { BarWave } from 'react-cssfx-loading';
// eslint-disable-next-line max-len
// import { useGetUserQuery, useSubmitUserMutation } from '../../redux/private/usermanagement/userSlice';
import { useGetUserQuery, useSubmitUserMutation } from '../../../redux/apiSlice';
import TextInputField from '../../components/FormsElements/TextInputField';
import SubmitButton from '../../../components/Forms/FormFields/SubmitButton';

const UserForm = () => {
  const { usr } = useParams();
  const [submitUser, transaction] = useSubmitUserMutation();
  const {
    data: user,
    isLoading:
    usersLoadingStatus,
    isSuccess: usersSuccessStatus,
    isError: usersErrorStatus,
    error: usersError,
  } = useGetUserQuery(+usr);
  const [newUser, setNewUser] = useState({});

  useEffect(() => {
    if (user) {
      setNewUser(user);
    }
  }, [user]);

  console.log(usersLoadingStatus);
  console.log(usersSuccessStatus);
  console.log(usersErrorStatus);
  console.log(usersError);

  const handleChange = (e) => {
    e.preventDefault();
    setNewUser({
      ...newUser,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    submitUser(newUser);
  };

  let content;

  if (transaction.isLoading) {
    content = <BarWave color="#54c5fc" height="1rem" width="6rem" className="mt-48" />;
  } else if (transaction.isError) {
    content = (
      <>
        <div className="text-red-500 font-bold mt-48 text-center">An error occurred while adding the occurrence</div>
      </>
    );
  } else if (transaction.isSuccess) {
    content = (
      <>
        <div className="text-green-500 font-bold mt-48 text-center">Occurrence added successfully</div>
        ;
      </>
    );
  } else {
    content = (
      <>
        <form className="flex flex-wrap gap-10 bg-private mt-4 p-8 rounded-md w-2/3">
          <TextInputField
            label="Name"
            name="name"
            value={newUser.name ? newUser.name : ''}
            onChange={handleChange}
            type="text"
          />
          <TextInputField
            label="Username"
            name="username"
            value={newUser.username ? newUser.username : ''}
            onChange={handleChange}
            type="text"
          />
          <TextInputField
            label="Email"
            name="email"
            value={newUser.email ? newUser.email : ''}
            onChange={handleChange}
            type="text"
          />
          <TextInputField
            label="Phone Number"
            name="phone_number"
            value={newUser.phone_number ? newUser.phone_number : ''}
            onChange={handleChange}
            type="text"
          />
          <TextInputField
            label="Department"
            name="department"
            value={newUser.department ? newUser.department : ''}
            onChange={handleChange}
            type="text"
          />
          <TextInputField
            label="Position"
            name="position"
            value={newUser.position ? newUser.position : ''}
            onChange={handleChange}
            type="text"
          />
          <TextInputField
            label="Cateogry"
            name="category"
            value={newUser.category ? newUser.category : ''}
            onChange={handleChange}
            type="text"
          />
          <TextInputField
            label="Role"
            name="role"
            value={newUser.role ? newUser.role : ''}
            onChange={handleChange}
            type="text"
          />
          <SubmitButton label="Submit" handleSubmit={handleSubmit} />
        </form>
      </>
    );
  }
  return (
    <div className="p-8 w-full text-lg min-h-screen">
      {content}
    </div>
  );
};

export default UserForm;
